module.exports = __webpack_public_path__ + "media/images/lb/082-990e56df088cd1db30e08c063d4f7833.svg";